import ClearanceCertificateObligationDetails from './ClearanceCertificateObligationDetails'

export default ClearanceCertificateObligationDetails
